import { OtherLayoutStoreSlice, otherLayoutReducer } from "../features";

export interface OtherStoreSlices {
  otherLayout: OtherLayoutStoreSlice;
}

export const otherReducers = {
  otherLayout: otherLayoutReducer,
};
